<script setup lang="ts">
import { useI18n } from 'vue-i18n';

withDefaults(defineProps<{
  value?: any;
}>(), {
  value: null,
});

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col items-center">
    <div class="w-full text-left">
      <p v-if="value" class="text-black font-light text-xs leading-relaxed mb-6">
        {{ t('components.diamonds.details.stoneType.selected') }}:
        <strong>
          <template v-if="value === 'earth'">
            {{ t('components.diamonds.details.stoneType.earth') }}
          </template>
          <template v-else>
            {{ t('components.diamonds.details.stoneType.lab') }}
          </template>
        </strong>
      </p>
      <p class="text-black font-light text-xs leading-relaxed whitespace-pre-line">
        {{ t('components.diamonds.details.stoneType.text') }}
      </p>
    </div>
  </div>
</template>

<style scoped>
</style>